import { Loader, Skeleton } from "@mantine/core";
import { Divider, message } from "antd";
import _ from "lodash";
import { useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { getAllLabActivities, getAllLaboratories, getLaboratories, putLaboratories } from "../../../helpers/api";
import AddLaboratoryComponent from "./add-laboratory";
import { ErrorBoundary } from "../../../components";

const EditLaboratoryComponent = ( { consultationId, onRefresh } ) => {
    const [ laboratories, setLabs ] = useState( [] );
    const [ consultation, setConsultation ] = useState( {} );

    const { data: serverActivities = [] } = useQuery( {
        queryFn: () => getAllLabActivities(),
        queryKey: [ 'lab-activities' ],
    } );

    const { isError, isFetching, refetch } = useQuery( {
        queryFn: () => getLaboratories( consultationId ),
        queryKey: [ 'laboratories', consultationId ],
        onSuccess: data => {
            // add the recordId field to fetched data to enable tracking
            const newSet = data.map( ( d, i ) => {
                return {
                    isComplete: d.isComplete,
                    id: d.laboratoryId,
                    laboratoryId: d.laboratoryId,
                    labType: d.labType,
                    requestType: d.requestType,
                    region: d.laboratory.region,
                    recordId: ++i
                };
            } );
            setLabs( newSet );
            setConsultation( data[ 0 ]?.consultation );
        }
    } );

    const { data: serverLabs = [] } = useQuery( {
        queryFn: () => getAllLaboratories(),
        queryKey: [ 'laboratories' ],
    } );


    const { mutateAsync: updateLaboratories, isLoading } = useMutation( ( data ) => putLaboratories( consultationId, data ), {
        onSuccess: ( data, variables, context ) => {
            if ( data.status === 200 ) {
                message.success( data.data.message );
                onRefresh();
                refetch();
                return;
            }
            throw data;
        },
        onError: ( error, variables, context ) => {
            const err = error.response.data.message;
            if ( _.isArray( err ) ) {
                err.map( err =>
                    message.error( err.message )
                );
            }
            else {
                message.error( err );
            }
        },
    } );


    // laboratory
    const handleAddLaboratory = () => {
        setLabs( [
            ...laboratories,
            {
                recordId: laboratories.length + 1,
                laboratoryId: null,
                labType: "",
                requestType: "",
            }
        ] );
    };

    const handleUpdateLaboratory = ( recordId, field, value ) => {
        let currentLab = laboratories.filter( lab => lab.recordId === recordId )[ 0 ];
        currentLab[ field ] = value;
        setLabs( [
            ...laboratories.filter( lab => lab.recordId !== recordId ),
            currentLab
        ] );
    };

    const handleDeleteLaboratory = ( recordId ) => {
        const updated = laboratories.filter( lab => lab.recordId !== recordId );
        setLabs( updated );
    };


    return (
        <>
            {
                isFetching ?
                    <div className="text-center"><Loader /> please wait...</div>
                    :
                    isError ?
                        <kbd className="bg-danger p-2">Sorry, we encountered an error processing your request</kbd>
                        :
                        <div className="row mb-1">
                            <ErrorBoundary fallback={ <kbd className="bg-danger p-2">Sorry, we encountered an error processing your request</kbd> }>
                                {
                                    laboratories.map( ( lab, index ) =>
                                        <>
                                            <div className="col-1"><kbd>{ ++index }</kbd></div>
                                            <div className="col-11">
                                                {
                                                    _.isEmpty( serverActivities ) ?
                                                        <Skeleton>loading..</Skeleton> :
                                                        <AddLaboratoryComponent
                                                            allActivities={ serverActivities }
                                                            allLaboratories={ serverLabs } key={ lab.id } data={ lab }
                                                            onUpdate={ handleUpdateLaboratory } onDelete={ handleDeleteLaboratory } />
                                                }
                                            </div>
                                            <Divider />
                                        </>
                                    )
                                }
                            </ErrorBoundary>
                        </div>
            }
            {
                !consultation?.isComplete &&
                <>
                    <div>
                        <button className={ `button is-small mt-2 ${ isLoading && ' is-loading ' }` }
                            onClick={ handleAddLaboratory }>Add Laboratory</button>
                    </div>
                    <button onClick={ () => updateLaboratories( laboratories ) }
                        id="submit" className={ `button h6 app-btn btn-prim mt-3 ${ isLoading && ' is-loading ' }` }>
                        Update Laboratories
                    </button>
                </>
            }
        </>
    );
};

export default EditLaboratoryComponent;
